import { render, staticRenderFns } from "./PricelistDataEdition.vue?vue&type=template&id=f66820ce&scoped=true&"
import script from "./PricelistDataEdition.vue?vue&type=script&lang=js&"
export * from "./PricelistDataEdition.vue?vue&type=script&lang=js&"
import style0 from "./PricelistDataEdition.vue?vue&type=style&index=0&id=f66820ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f66820ce",
  null
  
)

export default component.exports